import styled from "styled-components";

export const Unknown = styled.h1`
  text-align: center;
`;

export const UnknownImage = styled.div`
  text-align: center;
`;
